<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;}
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

    @keyframes burpee-1 {
    0% {
      opacity: 1;
    }
    33%,
    100% {
      opacity: 0;
    }
  }
  #burpee-1 {
    animation-name: burpee-1;
  }
  @keyframes burpee-2 {
    0%,
    33% {
      opacity: 0;
    }
    33%,
    66% {
      opacity: 1;
    }
    66%,
    100% {
      opacity: 0;
    }
  }
  #burpee-2 {
    animation-name: burpee-2;
  }
  @keyframes burpee-3 {
    0%,
    66% {
      opacity: 0;
    }
    66%,
    100% {
      opacity: 1;
    }
  }
  #burpee-3 {
    animation-name: burpee-3;
  }
  
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.2 383.2" height="100%" width="100%"> //350 300
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="burpee-3">
      <path
        fill="var(--flesh)"
        d="M224 313a37 37 0 0 1-1 4 29 29 0 0 0-2 10c1 8-2 15-3 22l-2 18c-1 3 0 4 2 3 2 0 3-1 4 1 0 2 2 2 3 2 3-1 6 0 9 1 3 0 4 2 6 4v3l-3 1c-1-1-3-1-2 1h-4c-6-2-12-1-18-1-5-2-6-4-6-10a87 87 0 0 0 0-18c-1-2-1-3-3-3-8-1-11-4-10-12l2-33c0-2 1-5 3-7 6 0 6 0 4 6a22 22 0 0 0 0 3c0 2 1 3 4 3h12c2 0 4 0 5 2Zm-18-1c-3 9-4 17-5 26a6 6 0 0 0 0 3 3 3 0 0 0 4 2c2-1 1-2 1-3l1-17a23 23 0 0 0-1-11Z"
      />
      <path
        fill="var(--hair)"
        d="M268 289c-3 2-6 1-9 0l1-3c0-4-1-5-4-4-1 1-2 0-3-1a6 6 0 0 0-4-2 15 15 0 0 1-5 0c-1-1-3-1-3-3-1-2 1-2 2-3 2-1 4-2 3-5-2-2-3-1-5-1-3 1-6 4-9 2l-1-4c6-2 11-5 17-6 7-2 12 0 15 7a50 50 0 0 1 3 17c0 2 0 3 2 4Z"
      />
      <path
        fill="var(--shirt)"
        d="m231 265 1 4a3 3 0 0 0-1 3c0 6-3 13-2 20a2 2 0 0 1-1 3 73 73 0 0 0-2 12c0 2 0 4-2 6-1-2-3-2-5-2h-12c-3 0-4-1-4-3a22 22 0 0 1 0-3c2-6 2-6-4-6a5 5 0 0 0-1-1h-16c-9 1-17 5-25 8a52 52 0 0 1-6 1c-2 1-2-1-3-2l-2-9c-2-10-1-21-4-31 4-2 9-6 15-4l8-2c18-5 37-4 55 1 2 1 5 1 7 4a4 4 0 0 0 4 1Z"
      />
      <path
        fill="var(--flesh)"
        d="M116 317c-1 2-4 2-5 3-5 2-9 4-14 4l-7 3a54 54 0 0 1-18 5 18 18 0 0 0-7 2 115 115 0 0 1-19 8c-5 1-9 1-12 4a23 23 0 0 0-8 6 15 15 0 0 0-2 1c-3 1-8 1-11-2-1-1-2-3 0-5l2-5a33 33 0 0 0 14-8c5-2 11-4 13-10a76 76 0 0 0 17-8c8-5 16-9 25-8 6 0 9-4 13-8l6-2 13 20Z"
      />
      <path
        fill="var(--pants)"
        d="m116 317-13-20a14 14 0 0 1 4-7 196 196 0 0 0 19-17 24 24 0 0 1 16-8c3 10 2 21 4 31 1 3 3 6 2 9-7 7-17 11-27 14-1 1-2 1-2-1-1-2-2-1-3-1Z"
      />
      <path
        fill="var(--hair)"
        d="m15 341-2 5v5c3 2 8 3 11 2a15 15 0 0 1 3-1c-1 3-2 6-1 10l2 3a35 35 0 0 1 8 3 3 3 0 0 1 0 5c-6 3-12 5-19 3-3-1-6-2-7-6l-9-18c-3-6 0-9 7-10a46 46 0 0 1 7-1ZM34 346c3-3 8-3 12-4-1 3 0 4 3 5 2 1 4 2 3 5s-2 2-4 3a24 24 0 0 1-4 0c-5 1-7 0-9-6l-1-3ZM43 323c-3 6-9 8-14 10-2-6-1-7 5-8l7-2h2Z"
      />
      <path
        fill="var(--flesh)"
        d="M228 295a2 2 0 0 0 1-3c-1-7 2-13 2-20a3 3 0 0 1 1-3c3 2 6-1 9-2 2 0 3-1 5 1 1 3-1 4-3 5-1 1-3 1-2 3 0 2 2 2 3 3a15 15 0 0 0 5 0 6 6 0 0 1 4 2c1 1 2 2 3 1 3-1 4 0 4 4l-1 3c-5 3-11 3-15 7a2 2 0 0 1-2 1c-5-2-9-1-14-2Z"
      />
    </g>
    <g id="burpee-2">
      <path
        fill="var(--flesh)"
        d="M196 301a41 41 0 0 0-19-3l-4-1c-2 0-5 0-5-2-1-2 1-3 2-4a67 67 0 0 1 5-6c5-5 10-10 17-12 4 2 8 7 13 8s5 5 5 9c0 2 1 3 3 3a12 12 0 0 0 5-2c5-2 13-1 17 3l-3 17v9c2 7-1 13-3 19-1 3 0 5 3 5a2 2 0 0 1 0 1c2 0 5 0 5 2-1 3-4 3-6 2-4-1-4 2-4 5l-2 11c-1 4 0 6 5 7a78 78 0 0 0 14 3 5 5 0 0 1 3 1c1 1 3 1 2 3 0 2-1 3-3 2-2 0-3 1-3 2h-3c-5-2-10-1-16-2-4-2-8-3-9-8a21 21 0 0 0-1-10c0-4 1-8-1-12v-2a2 2 0 0 0 1-2c0-11-2-22 0-33-4 2-5 5-6 8-3 8-8 14-11 21a48 48 0 0 0-4 11c-1 4-4 7-9 6a6 6 0 0 1-5-7c1-4 3-8 1-12 2 0 1-2 2-4 3-5 5-9 5-15 0-5 3-10 6-15l4-4c2-2 1-3-1-2Z"
      />
      <path
        fill="var(--shirt)"
        d="M235 294c-4-4-12-5-17-3a12 12 0 0 1-5 2c-2 0-3-1-3-3 0-4 0-8-5-9s-9-6-13-8c-1-3-4-3-6-4-12-5-24-10-38-7-4 1-8-2-10-6a8 8 0 0 0-2-3c0-1-2-3 0-3 9-4 17-9 26-12 10-4 20-4 31-3a100 100 0 0 1 32 8l9 1 2 3 1 13 1 7c3 9 0 17-3 26v1Z"
      />
      <path
        fill="var(--pants)"
        d="M136 253a8 8 0 0 1 2 3c2 4 6 7 10 6 14-3 26 2 38 7 2 1 5 1 6 4-7 2-12 7-17 12a67 67 0 0 0-5 6c-1 1-3 2-2 4 0 2 3 2 5 2l4 1-4 4c-1 2-3 3-5 0h-3c-1 2-3 2-5 0l-26-25a10 10 0 0 1-3-7c0-6 1-12 5-17Z"
      />
      <path
        fill="var(--hair)"
        d="M180 341c2 4 0 8-1 12a6 6 0 0 0 5 7c5 1 8-2 9-6a48 48 0 0 1 4-11c4 1 7 3 11 3a5 5 0 0 1 5 3v2c-6 3-12 3-17 4 3 4 8 6 18 8a21 21 0 0 1 1 10c-13 3-26 0-39-1-2-1-3-2-3-5s0-7 2-10v-3c0-5 2-10 3-14 0-1 1-1 2 1ZM236 244c-1-2 0-3 1-4a58 58 0 0 1 11-10c4-4 10-3 14 0 7 6 10 14 15 20 1 2 0 4-2 5h-5a9 9 0 0 0-2-5c0-1-2-2-3-1-2 3-6 3-9 5-1 1-3 2-4 0-2-2 1-2 1-4 2-1 3-3 1-5a4 4 0 0 0-6 0c-2 2-4 5-6 5l-5-6a2 2 0 0 0-1 0Z"
      />
      <path
        fill="var(--flesh)"
        d="M236 244a2 2 0 0 1 1 0l5 6c2 0 4-3 6-5a4 4 0 0 1 6 0c2 2 1 4-1 6 0 1-3 2-1 4 1 1 3 0 4-1 3-2 7-2 9-5 1-1 3 0 3 1a9 9 0 0 1 2 5c-3 3-4 6-7 7l-2 2c-2 9-10 6-15 9-2 1-3-1-4-2s-1-4-4-4l-1-6-1-14-2-3h2Z"
      />
    </g>
    <g id="burpee-1">
      <path
        fill="var(--flesh)"
        d="m187 82-1-52-1-24a14 14 0 0 1 0-6h3l6 6c0 6 0 13 2 19a9 9 0 0 1 0 5c-2 7 0 12 2 18 3 11 6 22 7 33l-1 7c3-1 5 1 8 1 1 4 2 7 1 11a2 2 0 0 0 1 1c6 7-1 13-2 19 0 2-2 2-3 2-2 0-5-1-6 1-2-3 0-6-1-9-5 2-13-2-14-7a4 4 0 0 0-2-4 3 3 0 0 1 0-2c4-6 3-13 1-19Z"
      />
      <path
        fill="var(--hair)"
        d="M170 363c2-2 2-5 3-8l3-4v6c0 4 4 6 5 4a91 91 0 0 1 9-7l1-2h2c3 8 10 12 18 16l5 3c4 3 4 7 0 9a64 64 0 0 1-8 3h-11l-7-3a28 28 0 0 0-11-5c-4-1-7-3-9-6Z"
      />
      <path
        fill="var(--shirt)"
        d="M186 103a4 4 0 0 1 2 3c1 6 9 10 14 8 1 3-1 6 1 9 5 6 12 12 15 21a28 28 0 0 1 2 14 173 173 0 0 0 0 45c1 6 1 6-4 8-8 2-17 4-26 3-5-1-10 0-14-3v-4c5-8 4-17 5-25 0-10-3-20-4-30v-15c0-7 3-13 5-19 1-3-2-5 0-7 4-1 3-5 4-8Z"
      />
      <path
        fill="var(--pants)"
        d="M176 211c4 3 9 2 14 3 9 1 18-1 26-3 1 3 2 5 1 8-1 1 0 2 1 2 1 10-1 19-2 29l-1 19c-1 2-2 4-4 4 0-4-1-5-5-5a130 130 0 0 0-15 1c-4 0-7 0-7 5-3-1-4-2-4-5a94 94 0 0 0-5-31 37 37 0 0 1 1-27Z"
      />
      <path
        fill="var(--flesh)"
        d="M184 274c0-5 3-5 7-5a130 130 0 0 1 15-1c4 0 5 1 5 5-3 10-6 19-12 28-4 6-4 14-3 21-3 6-5 12-5 19v11l-1 2a91 91 0 0 0-9 7c-1 2-5 0-5-4v-6a153 153 0 0 0-1-31 32 32 0 0 1 4-21 9 9 0 0 0 2-6 21 21 0 0 1 2-12c2-2 2-5 1-7Z"
      />
      <path
        fill="var(--hair)"
        d="M191 341c0-7 2-13 5-19 1-1 2 0 2 1 2 3 6 5 10 5l9 2c1 0 3 0 3 2s1 4-1 6a15 15 0 0 1-12 2c-5 0-11-1-16 1ZM212 89c-3-1-5-3-8-1l1-7a18 18 0 0 0 6 0c4 0 4 2 3 5a36 36 0 0 1-2 3ZM186 103c-1 3 0 7-4 8-3-7-5-15-2-23a9 9 0 0 1 7-6c2 6 3 13-1 19a3 3 0 0 0 0 2Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>